'use client';

import { jsx } from "react/jsx-runtime";
import a__default from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { forcedColorsSupport, colorToClassMap } from "./icons.css.js";
const iconSizeMapping = {
  sm: 16,
  md: 24,
  lg: 32
};
const hofPhosphorAdapter = (IconComponent, options) => {
  function IconFromPhosphor({ size = "md", color, filled = false, style, ...props }, ref) {
    const defaultWeight = a__default.useMemo(
      () => options?.bold ? "bold" : "regular",
      [options]
    );
    const extendedStyle = a__default.useMemo(() => {
      const s = iconSizeMapping[size];
      const excessHeightWorkaround = {
        // https://stackoverflow.com/a/75751695
        verticalAlign: "middle"
      };
      const nonResizableStyle = {
        minHeight: s,
        minWidth: s,
        maxHeight: s,
        maxWidth: s
      };
      return {
        ...excessHeightWorkaround,
        ...style,
        ...nonResizableStyle
      };
    }, [style, size]);
    return /* @__PURE__ */ jsx(
      IconComponent,
      {
        "aria-hidden": "true",
        focusable: false,
        ref,
        size: iconSizeMapping[size],
        weight: filled ? "fill" : defaultWeight,
        ...props,
        className: classNames(
          props.className,
          color && colorToClassMap[color],
          forcedColorsSupport
        ),
        style: extendedStyle
      }
    );
  }
  return a__default.forwardRef(IconFromPhosphor);
};
export {
  hofPhosphorAdapter,
  iconSizeMapping
};
